import { render, staticRenderFns } from "./ActionHabitsSetup.vue?vue&type=template&id=0811fd7b&scoped=true&"
import script from "./ActionHabitsSetup.vue?vue&type=script&lang=js&"
export * from "./ActionHabitsSetup.vue?vue&type=script&lang=js&"
import style0 from "./ActionHabitsSetup.vue?vue&type=style&index=0&id=0811fd7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0811fd7b",
  null
  
)

export default component.exports